module.exports = __webpack_public_path__ + "static/icons/icon-webcam-3f08314f5953ff75eced6e967d5967e3.svg";